import PAModal from "../../../../modules/modals/PAModal";
import { getThumbImage } from "../../../../util/helper/getThumbImage";
import OverviewHeaderProduct from "./OverviewHeaderProduct";
import styles from "./styles.module.scss";

function OverviewHeaderMobile(props: any) {
  const {
    children, show, handleExpandClose, title, className, getThumbImagePath = getThumbImage,
  } = props;

  if (!show) {
    return null;
  }

  return (
    <PAModal
      className={className}
      modelBodyClassName={styles.modalBody}
      dialogClassName={styles.overview_header_dialog}
      view="fromBottom"
      show={show}
      onHide={(e: any) => handleExpandClose(e)}
      header={{
        title,
        titleClass: `${styles.overview_modal_title}`,
      }}
      headerClassName={styles.overview_modal_mobile_header}
    >

      <div className="modal_content d-flex flex-column">
        <OverviewHeaderProduct {...props} getThumbImagePath={getThumbImagePath} />
        {children}
      </div>
    </PAModal>
  );
}

export default OverviewHeaderMobile;
